import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ForumPostBasicInfoComponent = ({
    selectedForumPost, handleInnerFormChange, forumTopics
}: any) => {

    console.log(selectedForumPost, "selectedForumPost")
    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="Topic"
                            labelField="Subject"
                            list={forumTopics}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TopicId'
                                )
                            }}
                            optionName='Choose Topic'
                            type="select"
                            value={selectedForumPost?.TopicId}
                            valueField="Id"
                        />

                        <div className="col-span-full">
                            <InputContainer
                                label="Text"
                                labelField="Text"
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Text'
                                    );
                                }}
                                type="text"
                                value={selectedForumPost?.Text}
                            />
                        </div>



                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}

export default ForumPostBasicInfoComponent;
